export const GET_DASHBOARD_LIST_REQUEST = "GET_DASHBOARD_LIST_REQUEST";
export const GET_DASHBOARD_LIST_SUCCESS = "GET_DASHBOARD_LIST_SUCCESS";
export const GET_DASHBOARD_LIST_FAIL = "GET_DASHBOARD_LIST_FAIL";

export const GET_DASHBOARD_WIDGET_LIST_REQUEST =
  "GET_DASHBOARD_WIDGET_LIST_REQUEST";
export const GET_DASHBOARD_WIDGET_LIST_SUCCESS =
  "GET_DASHBOARD_WIDGET_LIST_SUCCESS";
export const GET_DASHBOARD_WIDGET_LIST_FAIL = "GET_DASHBOARD_WIDGET_LIST_FAIL";

export const GET_CHART_DATA_REQUEST = "GET_CHART_DATA_REQUEST";
export const GET_CHART_DATA_SUCCESS = "GET_CHART_DATA_SUCCESS";
export const GET_CHART_DATA_FAIL = "GET_CHART_DATA_FAIL";

export const GET_WIDGET_COORDINATES = "GET_WIDGET_COORDINATES";

export const GET_CURRENT_DASHBOARD = "GET_CURRENT_DASHBOARD";

export const GET_NEW_DASHBOARD_DATA_REQUEST = "GET_NEW_DASHBOARD_DATA_REQUEST";
export const GET_NEW_DASHBOARD_DATA_SUCCESS = "GET_NEW_DASHBOARD_DATA_SUCCESS";
export const GET_NEW_DASHBOARD_DATA_FAIL = "GET_NEW_DASHBOARD_DATA_FAIL";

export const GET_CAMPAIGN_INSIGHTS_REQUEST = "GET_CAMPAIGN_INSIGHTS_REQUEST";
export const GET_CAMPAIGN_INSIGHTS_SUCCESS = "GET_CAMPAIGN_INSIGHTS_SUCCESS";
export const GET_CAMPAIGN_INSIGHTS_FAIL = "GET_CAMPAIGN_INSIGHTS_FAIL";

export const GET_ENGAGEMENT_DETAILS_REQUEST = "GET_ENGAGEMENT_DETAILS_REQUEST";
export const GET_ENGAGEMENT_DETAILS_SUCCESS = "GET_ENGAGEMENT_DETAILS_SUCCESS";
export const GET_ENGAGEMENT_DETAILS_FAIL = "GET_ENGAGEMENT_DETAILS_FAIL";

export const GET_CAMPAIGN_DASHBOARD_REQUEST = "GET_CAMPAIGN_DASHBOARD_REQUEST";
export const GET_CAMPAIGN_DASHBOARD_SUCCESS = "GET_CAMPAIGN_DASHBOARD_SUCCESS";
export const GET_CAMPAIGN_DASHBOARD_FAIL = "GET_CAMPAIGN_DASHBOARD_FAIL";

export const GET_MEETING_LOGS_REQUEST = "GET_MEETING_LOGS_REQUEST";
export const GET_MEETING_LOGS_SUCCESS = "GET_MEETING_LOGS_SUCCESS";
export const GET_MEETING_LOGS_FAIL = "GET_MEETING_LOGS_FAIL";
